<template>
  <transition :duration="{ enter: 0, leave: 500 }" name="fade" mode="out-in">
    <div v-if="loading" class="loader-container valign-wrapper center-align">
      <div class="spinner-container">
        <div class="preloader-wrapper active" v-bind:class="[type]">
          <div class="spinner-layer">
            <div class="circle-clipper left"><div class="circle"></div></div>
            <div class="gap-patch"><div class="circle"></div></div>
            <div class="circle-clipper right"><div class="circle"></div></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    type: {type: String, default: 'big'}
  }
}
</script>

<style lang="scss">
.loader-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255,255,255, 0.5);
  z-index: 1;

  .spinner-container {
    width: 100%;

    .circle-clipper .circle {
      border-width: 5px;
    }
    .small .circle-clipper .circle {
      border-width: 3px;
    }
    .big .circle-clipper .circle {
      border-width: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// loader.vue?00fa9a18